export default __webpack_public_path__ + "static/keys-6dd1705b5be46810283f8f9fd7059c3e.jpg";